module.exports = __webpack_public_path__ + "static/city_bn@2x-4af2312d4be1032740ab727502698968.png";